__turbopack_context__.v({
  "active": "qGuFZW_active",
  "bullet": "qGuFZW_bullet",
  "carousel-pointers": "qGuFZW_carousel-pointers",
  "carouselPointer": "qGuFZW_carouselPointer",
  "content": "qGuFZW_content",
  "description": "qGuFZW_description",
  "description-wrapper": "qGuFZW_description-wrapper",
  "embla": "qGuFZW_embla",
  "embla__container": "qGuFZW_embla__container",
  "embla__dot": "qGuFZW_embla__dot",
  "embla__dot--selected": "qGuFZW_embla__dot--selected",
  "embla__dots": "qGuFZW_embla__dots",
  "embla__slide": "qGuFZW_embla__slide",
  "load": "qGuFZW_load",
  "progress": "qGuFZW_progress",
  "quote-wrapper": "qGuFZW_quote-wrapper",
  "quoteCarousel": "qGuFZW_quoteCarousel",
  "quoteCarousel1": "qGuFZW_quoteCarousel1",
  "root": "qGuFZW_root",
  "space": "qGuFZW_space",
});
